import { API_URL } from '../Config/Config';
import {
  addPipelineLoader,
  rmPipelineLoader,
  serverError,
  serverMaintenance,
  setToken,
  setUser
} from '../Redux/Actions/authActions/authActions';
import Store from '../Redux/Store';
import KeycloakService from '../Services/KeycloakService';
import { apiRefreshToken } from './Login/Login';

const createHeader = async (
  token,
  accept,
  contentType = 'application/json'
) => {
  let tokenKeycloak = KeycloakService.getToken();

  // Refresh the token if it's about to expire
  if (KeycloakService.isTokenExpireSoon()) {
    const refreshed = await KeycloakService.updateToken();
    if (refreshed) {
      tokenKeycloak = KeycloakService.getToken();
    }
  }

  // Construct the headers based on content type
  const headers = {
    Authorization: `Bearer ${tokenKeycloak}`
  };

  if (contentType !== 'form-data') {
    headers['Content-Type'] = contentType;
    headers['Accept'] = accept;
  }

  return headers;
};
// async function processResponse (response, callback) {
//   const refreshToken = Store.getState().auth.refreshToken;
//   let responseJson;
//   try {
//     responseJson = await response.json();
//   } catch (e) {
//     return { statusCode: 500 };
//   }
//   if (responseJson.statusCode === 401) {
//     const res = await apiRefreshToken(refreshToken);
//     if (res.statusCode === 200) {
//       Store.dispatch(setToken(res));
//       return callback();
//     } else {
//       Store.dispatch(
//         setUser({ accessToken: '', refreshToken: '', user: null })
//       );
//       return null;
//     }
//   } else if (responseJson.statusCode === 200) {
//     return responseJson;
//   } else {
//     return responseJson;
//   }
// }

export async function processResponse(response, callback) {
  if (response.status === 500) {
    Store.dispatch(serverError());
  }
  if (response.status === 401) {
    window.location.replace('/Deconnection');
    setTimeout(
      () =>
        Store.dispatch(
          setUser({ accessToken: null, refreshToken: null, user: null })
        ),
      400
    );
    return null;
  } else if (response.status === 503) {
    Store.dispatch(serverMaintenance());
  } else {
    let responseJson;
    try {
      responseJson = await response.json();
    } catch (e) {
      // return { statusCode: 500 };
      if (response?.status) {
        responseJson = response;
      } else {
        return { statusCode: 500 };
      }
    }

    if (responseJson?.errors && !Array.isArray(responseJson?.errors)) {
      let newErrors = [];
      Object.keys(responseJson.errors).map((key) => {
        const errorsArray = responseJson.errors[key];
        newErrors = [...newErrors, ...errorsArray];
      });
      responseJson.errors = newErrors;
    }

    if (responseJson.length === undefined) {
      return { ...responseJson, status: response.status };
    } else {
      return { data: responseJson, status: response.status };
    }
  }
}

export async function apiGet(api, accept, disableLoader = false) {
  !disableLoader && Store.dispatch(addPipelineLoader(api));
  const token = Store.getState().auth.accessToken || '';

  const response = await fetch(API_URL + api, {
    method: 'Get',
    headers: await createHeader(token, accept)
  });

  if (response && !disableLoader) {
    Store.dispatch(rmPipelineLoader(api));
  }
  const resp = await processResponse(response, () => apiGet(api, accept));
  return resp;
}

export async function apiPost(
  api,
  body,
  accept,
  contentType = 'application/json',
  disableLoader = false
) {
  !disableLoader && Store.dispatch(addPipelineLoader(api));
  try {
    const token = Store.getState().auth.accessToken || '';
    const response = await fetch(API_URL + api, {
      method: 'POST',
      headers: await createHeader(token, accept, contentType),
      body: body
    });

    if (response && !disableLoader) {
      Store.dispatch(rmPipelineLoader(api));
    }

    return processResponse(response, () => apiPost(api, body, contentType));
  } catch (err) {
    Store.dispatch(rmPipelineLoader(api));
    return { status: 500 };
  }
}

export async function apiDelete(api, body, accept) {
  Store.dispatch(addPipelineLoader(api));

  const token = Store.getState().auth.accessToken || '';
  const response = await fetch(API_URL + api, {
    method: 'Delete',
    headers: await createHeader(token, accept, 'application/json'),
    body: body
  });

  if (response) {
    Store.dispatch(rmPipelineLoader(api));
  }

  return processResponse(response, () => apiDelete(api, body));
}

export async function apiPut(
  api,
  body,
  accept,
  contentType = 'application/json'
) {
  Store.dispatch(addPipelineLoader(api));

  const token = Store.getState().auth.accessToken || '';
  const response = await fetch(API_URL + api, {
    method: 'Put',
    headers: await createHeader(token, accept, contentType),
    body: body
  });
  if (response) {
    Store.dispatch(rmPipelineLoader(api));
  }

  return processResponse(response, () => apiPost(api, body, contentType));
}

export async function apiPostUpload(
  api,
  body,
  accept,
  contentType = 'form-data'
) {
  Store.dispatch(addPipelineLoader(api));

  const token = Store.getState().auth.accessToken || '';
  const response = await fetch(API_URL + api, {
    method: 'POST',
    headers: await createHeader(token, accept, contentType),
    body: body
  });
  if (response) {
    Store.dispatch(rmPipelineLoader(api));
  }
  return processResponse(response, () => apiPost(api, body, contentType));
}

export async function apiPatch(
  api,
  body,
  accept,
  contentType = 'application/json'
) {
  Store.dispatch(addPipelineLoader(api));

  const token = Store.getState().auth.accessToken || '';
  const response = await fetch(API_URL + api, {
    method: 'PATCH',
    headers: await createHeader(token, accept, contentType),
    body: body
  });
  if (response) {
    Store.dispatch(rmPipelineLoader(api));
  }
  return processResponse(response, () =>
    apiPost(api, body, accept, contentType)
  );
}
